import { render, staticRenderFns } from "./DownloadSuppliersToExcel.vue?vue&type=template&id=744bb628"
import script from "./DownloadSuppliersToExcel.vue?vue&type=script&lang=js"
export * from "./DownloadSuppliersToExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports